import { canSwapMission } from './chipUtils';
import type { GameState } from './types';

export function getActivePlayerIndex(state: GameState): number {
  if (state.phase === 'settlement') {
    return state.settlementIndex;
  }
  return state.activePlayerIndex;
}

export function getPhaseDetail(state: GameState): string {
  switch (state.phase) {
    case 'mission_draft':
      return `미션 드래프트 ${state.missionDraftRound + 1}/5`;
    case 'round_roll':
      return '주사위 굴리기 대기';
    case 'mission_select':
      return '미션 카드 선택';
    case 'betting':
      return '베팅';
    case 'draft':
      return `주사위 배치 ${state.draftTurn}/4턴`;
    case 'settlement':
      return '미션 공개 · 정산';
    case 'final_score':
      return '최종 점수 계산';
    case 'game_over':
      return '게임 종료';
    case 'setup':
      return '플레이어 수 선택';
    default:
      return '';
  }
}

export function getPlayerDisplayName(state: GameState, playerIndex: number): string {
  const player = state.players[playerIndex];
  if (!player) return `플레이어 ${playerIndex + 1}`;
  if (player.isHuman) return '나';
  return player.name;
}

export function getActorLabel(state: GameState, botActingIndex: number | null): string {
  if (state.phase === 'setup' || state.phase === 'game_over' || state.phase === 'final_score') {
    return '';
  }

  const actorIndex = getActivePlayerIndex(state);
  const name = getPlayerDisplayName(state, actorIndex);
  const player = state.players[actorIndex];

  if (botActingIndex !== null && botActingIndex === actorIndex && player && !player.isHuman) {
    return `${name} · AI 행동 중`;
  }

  if (player?.isHuman) {
    return `${name} · 차례`;
  }

  return `${name} · 차례`;
}

export function canPlayerSwapMission(state: GameState, playerIndex: number): boolean {
  if (state.phase !== 'draft' || state.draftTurn < 1 || state.draftTurn > 3) {
    return false;
  }
  if (state.activePlayerIndex !== playerIndex) {
    return false;
  }
  const player = state.players[playerIndex];
  if (!player || player.missionSwappedThisRound || !player.selectedMissionId) {
    return false;
  }
  return canSwapMission(player.betAmount, state.draftTurn);
}

export function isHumanTurn(state: GameState): boolean {
  if (state.phase === 'setup' || state.phase === 'game_over' || state.phase === 'final_score') {
    return false;
  }
  if (state.phase === 'round_roll') {
    return true;
  }
  const actorIndex = getActivePlayerIndex(state);
  return state.players[actorIndex]?.isHuman ?? false;
}
